const welcomeModal = document.getElementById('welcome-popup');
const hideModalCookie = getCookie('hide_welcome_popup');

if (!hideModalCookie) {
    $(welcomeModal).modal('show');

    $(welcomeModal)
        .on('show.bs.modal', function (e) {
            const modalContent = e.target.querySelector('.modal-content');
            const modalWidth = Number(modalContent.style.minWidth.replace(/[(px),%,(r?em)]/g, ''));
            if (window.screen.width <= modalWidth) {
                modalContent.removeAttribute('style');
            }
        })
        .on('shown.bs.modal', function (e) {
            const movie = e.target.querySelector('.movie');
            if (movie) {
                window.modalPlayer = new Plyr(movie, {
                    youtube: {noCookie: false, rel: 0, showinfo: 0, iv_load_policy: 3, modestbranding: 1}
                });
                modalPlayer.on('play', function (e) {
                    const instance = e.detail.plyr;
                    instance.fullscreen.enter();
                });
            }
        })
        .on('hidden.bs.modal', function (e) {
            modalPlayer.stop();
        });
}


// 이벤트
const churchEvents = document.getElementById('events');
const fetchChurchEvents = async () => {
    try {
        const r = await axios.get('/api/church-events');
        for (const evt of r.data) {
            const {
                subject, from, time, place
            } = evt;
            const tpl = document.getElementById('church-event-tpl')
                .content
                .cloneNode(true);
            const el = tpl.firstElementChild;
            el.querySelector('.date').innerText = from;
            if (time) {
                el.querySelector('.time').innerText = time;
            } else {
                el.querySelector('.time')
                    .remove();
            }
            if (place) {
                el.querySelector('.place').innerText = place;
            } else {
                el.querySelector('.place')
                    .remove();
            }
            el.querySelector('.subject').innerText = subject;
            churchEvents.appendChild(tpl);
        }

        if (r.data.length === 0) {
            const tpl = document.getElementById('church-no-event-tpl')
                .content
                .cloneNode(true);
            churchEvents.appendChild(tpl);
        }

        $(churchEvents)
            .slick({
                autoplay: false,
                dots: false,
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: true,
                responsive: [
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            });
    } catch (err) {
        console.log(err);
    }
};

if (churchEvents) {
    fetchChurchEvents();
}

function makePostCode(objs) {
    const html = [];
    if (objs.length && objs.length > 0) {
        for (const obj of objs) {
            const {postLink, date, title} = obj;
            const code = `<div class="news-letter-item">
                            <a href="${postLink}">
                                <span class="date mr-2"><i data-feather="calendar"></i> ${date}</span>
                                <span class="title">${title}</span>
                            </a>
                        </div>`;
            html.push(code);
        }
    }

    return html.join('\n');
}

const subscriptionForm = document.getElementById('news-subscription-form');
if (subscriptionForm) {
    subscriptionForm.addEventListener('submit', async e => {

        e.preventDefault();

        const msgContainer = document.getElementById('subscription-apply-result');

        try {
            const fd = new FormData(e.target);
            const res = await axios.post('/subscription', fd);

            msgContainer.classList.add('text-success');
            msgContainer.innerText = res.data.message;
            showAlert('성공', res.data.message);

            setTimeout(() => {
                e.target.reset();
                msgContainer.innerText = '';
            }, 3000);

        } catch (err) {
            msgContainer.classList.add('text-danger');
            msgContainer.innerHTML = '';

            if (err.response && err.status === 419) {
                if (err.response.errors.email) {
                    // eslint-disable-next-line prefer-destructuring
                    msgContainer.innerText = err.response.errors.email[0];
                }
                if (err.response.errors.name) {
                    msgContainer.innerHTML = `${msgContainer.innerText}<br>${err.response.errors.name[0]}`;
                }
            } else {
                msgContainer.innerText = 'Error';
            }
        }
    });
}
